module.exports = __webpack_public_path__ + "media/images/emoticons/bud-74f073739ad1e77a85464191e72115c8.gif";